/**
 * Pure helpers extracted from the 2026-07-05 QA bug-fix batch so the exact
 * bug logic can be regression-tested without rendering the components.
 * Each function encodes the fix for a specific reported bug; the matching
 * test file is src/utils/qaFixes.test.js.
 */

// ── Bug: Servers → wrong server counts ────────────────────────────────────────
// The raw `servers` array includes rows tagged 'kubernetes', which are
// duplicates of cluster nodes. Baremetal = non-kubernetes rows.
export function baremetalOf(servers) {
  return (servers || []).filter(sv => (sv.segment || 'unassigned') !== 'kubernetes');
}

// True inventory total = baremetal servers + live k8s nodes (never raw
// servers.length, which double-counts the kubernetes-tagged duplicates).
export function totalServerCount(servers, totalK8sNodes) {
  return baremetalOf(servers).length + (totalK8sNodes || 0);
}

// Per-segment baremetal count (used by the sidebar segment items).
export function segmentCount(servers, segment) {
  return baremetalOf(servers).filter(sv => (sv.segment || 'unassigned') === segment).length;
}

// ── Bug: Events → Object-column filter not working ────────────────────────────
// The Object column renders `${object_kind}/${object_name}`, so the
// object/message filter must match kind + name + message (not just name), and
// be null-safe so a missing field doesn't throw and kill the whole filter.
export function eventMatches(ev, nsFilter, textFilter) {
  const q = (v) => (v || '').toString().toLowerCase();
  const nf = (nsFilter || '').toLowerCase();
  const tf = (textFilter || '').toLowerCase();
  const ns = !nf || q(ev.namespace).includes(nf);
  const text = !tf
    || q(ev.object_name).includes(tf)
    || q(ev.object_kind).includes(tf)
    || q(ev.message).includes(tf);
  return ns && text;
}
